import { useTranslation } from "react-i18next";
import { passagePreview } from "../memoryActions";

export interface ListedPassage {
  readonly key: string;
  readonly quote: string;
  /** The entry it is quoted from, as a number or as its reference. */
  readonly entry: number | string;
}

/**
 * The passages a memory quotes, as the keep preparation and the keep and review steps show
 * them. `full` shows each passage whole, as a review must (an approver confirms exactly what
 * it quotes); otherwise each is shortened to a preview.
 */
export default function PassageList({ passages, className = "space-y-2", full = false }: { passages: readonly ListedPassage[]; className?: string; full?: boolean }) {
  const { t } = useTranslation();
  return (
    <ul className={className}>
      {passages.map((passage) => (
        <li key={passage.key} className="app-card-muted space-y-1 border-l-4 border-l-[var(--app-accent)] p-2 text-sm">
          <blockquote className="whitespace-pre-wrap">{full ? passage.quote : passagePreview(passage.quote, 400)}</blockquote>
          <p className="app-text-muted text-xs">{t("memories.keep.fromEntry", { number: passage.entry })}</p>
        </li>
      ))}
    </ul>
  );
}
